export default __webpack_public_path__ + "static/1122-898a3520cdc109a8479fbb6dfd0e933a.gif";